import { Service } from '@roc/feature-app-core';

const url = {
  GET_LOANS_IN_PENDING_STATUS_GRID: '/api/v1/utility/loansInPendingStatus/getLoansInPendingStatus'
};

export class LoansInPendingStatusService extends Service {

  getLoansInPendingStatusGrid(urlParams: string) {
    return this.get(
      `${url.GET_LOANS_IN_PENDING_STATUS_GRID}?${urlParams}`
    );
  }
}
